import { configureStore } from "@reduxjs/toolkit";
import { answersSlice } from "./answersSlice";
import { coverSlice } from "./coverSlice";
import { photosSlice } from "./photosSlice";
import { templatesSlice } from "./templatesSlice";
import { pageSlice } from "./pageSlice";
import { editingSlice } from "./editingSlice";
import { previewSlice } from "./previewSlice";

export const store = configureStore({
  reducer: {
    answers: answersSlice.reducer,
    templates: templatesSlice.reducer,
    cover: coverSlice.reducer,
    photos: photosSlice.reducer,
    page: pageSlice.reducer,
    editing: editingSlice.reducer,
    preview: previewSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
